import { type FooterAccordionItem } from './FooterAccordion'

const createTextLink = (text: string, href: string) => ({
  '@type': '@builder.io/sdk:Element',
  '@version': 2,
  component: {
    name: 'Text',
    options: {
      text: `<p>${text}</p>`,
      style: 'Body SM',
      actionName: 'navigate',
      navigate: {
        href,
        analyticsEvent: 'select cta',
        target: '_self',
      },
    },
  },
  responsiveStyles: {
    large: {
      color: '#444646',
      cursor: 'pointer',
      marginBottom: '12px',
      width: 'fit-content',
    },
  },
})

const createTitle = (text: string) => ({
  '@type': '@builder.io/sdk:Element',
  '@version': 2,
  component: {
    name: 'Text',
    options: {
      text: `<p>${text}</p>`,
      style: 'Body MD - Medium weight',
      actionName: 'none',
    },
  },
  responsiveStyles: {
    large: {
      color: 'rgba(22, 24, 25, 1)',
    },
  },
})

export const defaultItems: FooterAccordionItem[] = [
  {
    titleContent: [createTitle('Explore')],
    content: [
      createTextLink('Home', '/'),
      createTextLink('BODi Programs', '/'),
      createTextLink('Results & Success Stories', '/'),
      createTextLink('Blog', '/'),
      createTextLink('Facebook Community', '/'),
      createTextLink('Become an Affiliate', '/'),
      createTextLink('The BODi Experience', '/'),
      createTextLink('Refer & Earn', '/'),
    ],
  },
  {
    titleContent: [createTitle('Account & Support')],
    content: [
      createTextLink('My Account', '/'),
      createTextLink('My Orders', '/'),
      createTextLink('My Subscriptions', '/'),
      createTextLink('BODi Support', '/'),
    ],
  },
  {
    titleContent: [createTitle('Company')],
    content: [
      createTextLink('Careers', '/'),
      createTextLink('About Us', '/'),
      createTextLink('Contact Information', '/'),
      createTextLink('Investor', '/'),
      createTextLink('Press Inquiries', '/'),
    ],
  },
  {
    titleContent: [createTitle('Legal')],
    content: [
      createTextLink('Terms and Conditions', '/'),
      createTextLink('Privacy Policy', '/'),
      createTextLink('Consumer Health Data Policy', '/'),
      createTextLink('Do Not Sell My Info', '/'),
      createTextLink('Accessibility Statement', '/'),
      createTextLink('Supplier Code', '/'),
      createTextLink('California Supply Chain', '/'),
    ],
  },
]
